<template>
    <div class="login-wrapper">
        <div class="login-card">
            <div class="login-card__header">
                <img src="../assets/img/logo_abft_new_alt.png" alt="ABFT" class="login-card__logo">
                <h2 class="login-card__title">Intranet</h2>
            </div>

            <div class="login-card__body overlay-wrapper">
                <div class="overlay" v-if="loggingIn">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>

                <div class="login-card__error" v-if="error">
                    <i class="fa fa-exclamation-circle"></i>
                    {{ error }}
                </div>

                <form method="POST" role="form" @submit.prevent="sendLoginForm">
                    <input type="hidden" name="_token" value="">

                    <div class="login-card__field">
                        <label for="login-email"><i class="fa fa-envelope-o"></i> Adresse e-mail</label>
                        <input
                                id="login-email"
                                name="username"
                                autocomplete="email"
                                data-id="login.username"
                                class="login-card__input"
                                placeholder="votre@email.com"
                                v-model="credentials.username"
                        >
                    </div>
                    <div class="login-card__field">
                        <label for="login-password"><i class="fa fa-lock"></i> Mot de passe</label>
                        <input
                                id="login-password"
                                name="password"
                                autocomplete="password"
                                type="password"
                                class="login-card__input"
                                placeholder="Votre mot de passe"
                                v-model="credentials.password"
                        >
                    </div>
                    <button type="submit" data-id="login.submit"
                            class="login-card__btn"
                            :disabled="loggingIn">
                        <span v-if="!loggingIn">Se connecter</span>
                        <span v-if="loggingIn"><i class="fa fa-spinner fa-spin"></i> Connexion...</span>
                    </button>
                </form>
            </div>

            <div class="login-card__footer">
                Association Belge Francophone de Taekwondo
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        data() {
            return {
                credentials: {
                    username: '',
                    password: ''
                },
                loggingIn: false,
                error: ''
            }
        },
        methods: {
            sendLoginForm: function () {
                this.loggingIn = true
                const credentials = {
                    username: this.credentials.username,
                    password: this.credentials.password
                }
                // Auth.login() returns a promise. A redirect will happen on success.
                // For errors, use .then() to capture the response to output
                // error_description (if exists) as shown below:
                this.$auth.login(credentials, 'Dashboard').then((response) => {
                    this.loggingIn = false
                    this.error = response.body
                })
            }
        }
    };
</script>

<style>
    body.login-page {
        background: #1e2a35 !important;
    }
    body.login-page .wrapper {
        background: transparent !important;
    }
</style>
<style scoped>
    .login-wrapper {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #1e2a35 0%, #2a4060 50%, #3B7BBE 100%);
        padding: 20px;
        position: relative;
        overflow: hidden;
    }
    .login-wrapper::before {
        content: '';
        position: absolute;
        top: -50%;
        right: -20%;
        width: 600px;
        height: 600px;
        background: radial-gradient(circle, rgba(90, 159, 212, 0.15) 0%, transparent 70%);
        border-radius: 50%;
    }
    .login-wrapper::after {
        content: '';
        position: absolute;
        bottom: -30%;
        left: -10%;
        width: 400px;
        height: 400px;
        background: radial-gradient(circle, rgba(59, 123, 190, 0.1) 0%, transparent 70%);
        border-radius: 50%;
    }

    .login-card {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        border-radius: 12px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        position: relative;
        z-index: 1;
    }

    .login-card__header {
        text-align: center;
        padding: 35px 30px 20px;
        background: linear-gradient(180deg, #f8fafb 0%, #ffffff 100%);
        border-bottom: 1px solid #eef2f5;
    }
    .login-card__logo {
        max-width: 180px;
        height: auto;
        margin-bottom: 10px;
    }
    .login-card__title {
        font-size: 16px;
        font-weight: 300;
        color: #7a8fa0;
        letter-spacing: 3px;
        text-transform: uppercase;
        margin: 0;
    }

    .login-card__body {
        padding: 30px 35px 20px;
    }

    .login-card__error {
        background: #fef2f2;
        border: 1px solid #fecaca;
        color: #dc2626;
        padding: 10px 14px;
        border-radius: 8px;
        font-size: 13px;
        margin-bottom: 20px;
    }
    .login-card__error .fa {
        margin-right: 6px;
    }

    .login-card__field {
        margin-bottom: 20px;
    }
    .login-card__field label {
        display: block;
        font-size: 12px;
        font-weight: 600;
        color: #4a5568;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 6px;
    }
    .login-card__field label .fa {
        color: #3B7BBE;
        width: 16px;
        text-align: center;
    }
    .login-card__input {
        width: 100%;
        padding: 12px 16px;
        font-size: 14px;
        color: #2d3748;
        background: #f7f9fb;
        border: 2px solid #e2e8f0;
        border-radius: 8px;
        outline: none;
        transition: all 0.2s ease;
        box-sizing: border-box;
    }
    .login-card__input:focus {
        border-color: #3B7BBE;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(59, 123, 190, 0.12);
    }
    .login-card__input::placeholder {
        color: #a0aec0;
    }

    .login-card__btn {
        width: 100%;
        padding: 13px;
        font-size: 15px;
        font-weight: 600;
        color: #ffffff;
        background: linear-gradient(135deg, #3B7BBE 0%, #5A9FD4 100%);
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.2s ease;
        letter-spacing: 0.5px;
        margin-top: 5px;
    }
    .login-card__btn:hover {
        background: linear-gradient(135deg, #2a5f96 0%, #4a8fc4 100%);
        box-shadow: 0 4px 15px rgba(59, 123, 190, 0.4);
        transform: translateY(-1px);
    }
    .login-card__btn:active {
        transform: translateY(0);
    }
    .login-card__btn:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        transform: none;
    }

    .login-card__footer {
        text-align: center;
        padding: 15px 30px 20px;
        font-size: 11px;
        color: #a0aec0;
        letter-spacing: 0.3px;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        border-radius: 12px;
    }
    .overlay .fa {
        font-size: 28px;
        color: #3B7BBE;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue